
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'embedded-viral-link-ui',
  currentProjectVersion: 'static-1.6327',
  depVersions: {
  "embedded-viral-link-ui": "static-1.6327",
  "head-dlb": "static-1.4938",
  "hs-test-utils": "static-1.7936",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11383",
  "I18n": "static-7.1606",
  "jasmine-runner": "static-1.6391",
  "quartz": "static-1.6899",
  "quartz-core": "static-1.6118",
  "react-dlb": "static-1.77",
  "webpack-env": "static-1.54",
  "cssUtils": "static-1.773",
  "enviro": "static-4.428",
  "foundations-components": "static-1.7778",
  "history": "static-4.47",
  "hub-http": "static-1.6145",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11691",
  "icons": "static-2.640",
  "immer": "static-1.33",
  "laboratory-lib": "static-3.7082",
  "PortalIdParser": "static-2.388",
  "quartz-config": "static-1.677",
  "quartz-routing": "static-1.329",
  "quick-fetch": "static-1.3856",
  "react": "static-7.184",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16583",
  "react-router-dom": "static-5.26",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5282",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "signup-constants": "static-1.18713",
  "signup-ui-lego-core": "static-1.20723",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.485",
  "ui-addon-react-router-dom": "static-1.9469",
  "ui-images": "static-2.1133",
  "UIComponents": "static-3.8330",
  "usage-tracker": "static-1.7260",
  "usage-tracker-core": "static-1.7110",
  "viral-links-lib": "static-1.6973",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven": "static-3.5829",
  "raven-hubspot": "static-1.6136",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.77",
  "metrics-js": "static-1.9542",
  "bend-plugin-trellis-migration": "static-1.3341",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3176",
  "quartz-webpack": "static-1.3123",
  "HeadJS": "static-2.737",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3047",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "foundations-theming": "static-1.4338",
  "i18n-data": "static-1.219",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4247",
  "dispatcher": "static-1.134",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.822",
  "hubspotter-http": "static-1.4591",
  "mobile-manifest-mixins": "static-1.511",
  "module-federation": "static-1.21",
  "quartz-auth": "static-1.574",
  "quartz-head": "static-1.564",
  "quartz-i18n": "static-1.574",
  "quartz-test": "static-1.574",
  "quartz-tracking": "static-1.278",
  "ui-fonts": "static-1.645",
  "usage-tracker-container": "static-1.7250",
  "sassPrefix": "static-1.154",
  "bend-plugin-foundations-components": "static-1.4047",
  "floating-ui": "static-1.54",
  "foundations-assets": "static-1.4775",
  "foundations-theming-specialty": "static-1.2054",
  "hs-story-utils": "static-1.9354",
  "react-aria": "static-1.64",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1594",
  "hs-locale-management": "static-1.23",
  "superstore": "static-1.4692",
  "csstype": "static-1.50",
  "rpc-client-utils": "static-1.4568",
  "emoji-regex": "static-1.7",
  "PatternValidationJS": "static-1.437",
  "signup-ui-url-generator": "static-2.7957",
  "bender-build-tools": "static-1.3093",
  "bend-plugin-foundations-theming": "static-1.2821",
  "foundations-theming-base": "static-1.3323",
  "stylex": "static-1.30",
  "hub-http-shared-msw-handlers": "static-1.9782",
  "hubspotter-http-shared-msw-handlers": "static-1.9780",
  "usage-tracker-session-replay": "static-1.4946",
  "chirp-fetch": "static-1.1806",
  "ts-schema": "static-1.4017",
  "amplitude-session-replay-browser": "static-1.58"
},
  depPathPrefixes: {
  "embedded-viral-link-ui": "/embedded-viral-link-ui/static-1.6327",
  "head-dlb": "/head-dlb/static-1.4938",
  "hs-test-utils": "/hs-test-utils/static-1.7936",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11383",
  "I18n": "/I18n/static-7.1606",
  "jasmine-runner": "/jasmine-runner/static-1.6391",
  "quartz": "/quartz/static-1.6899",
  "quartz-core": "/quartz-core/static-1.6118",
  "react-dlb": "/react-dlb/static-1.77",
  "webpack-env": "/webpack-env/static-1.54",
  "cssUtils": "/cssUtils/static-1.773",
  "enviro": "/enviro/static-4.428",
  "foundations-components": "/foundations-components/static-1.7778",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6145",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11691",
  "icons": "/icons/static-2.640",
  "immer": "/immer/static-1.33",
  "laboratory-lib": "/laboratory-lib/static-3.7082",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "quartz-config": "/quartz-config/static-1.677",
  "quartz-routing": "/quartz-routing/static-1.329",
  "quick-fetch": "/quick-fetch/static-1.3856",
  "react": "/react/static-7.184",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16583",
  "react-router-dom": "/react-router-dom/static-5.26",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5282",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "signup-constants": "/signup-constants/static-1.18713",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20723",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9469",
  "ui-images": "/ui-images/static-2.1133",
  "UIComponents": "/UIComponents/static-3.8330",
  "usage-tracker": "/usage-tracker/static-1.7260",
  "usage-tracker-core": "/usage-tracker-core/static-1.7110",
  "viral-links-lib": "/viral-links-lib/static-1.6973",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven": "/raven/static-3.5829",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.77",
  "metrics-js": "/metrics-js/static-1.9542",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3341",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3176",
  "quartz-webpack": "/quartz-webpack/static-1.3123",
  "HeadJS": "/HeadJS/static-2.737",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3047",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "foundations-theming": "/foundations-theming/static-1.4338",
  "i18n-data": "/i18n-data/static-1.219",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4247",
  "dispatcher": "/dispatcher/static-1.134",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.822",
  "hubspotter-http": "/hubspotter-http/static-1.4591",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.511",
  "module-federation": "/module-federation/static-1.21",
  "quartz-auth": "/quartz-auth/static-1.574",
  "quartz-head": "/quartz-head/static-1.564",
  "quartz-i18n": "/quartz-i18n/static-1.574",
  "quartz-test": "/quartz-test/static-1.574",
  "quartz-tracking": "/quartz-tracking/static-1.278",
  "ui-fonts": "/ui-fonts/static-1.645",
  "usage-tracker-container": "/usage-tracker-container/static-1.7250",
  "sassPrefix": "/sassPrefix/static-1.154",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4047",
  "floating-ui": "/floating-ui/static-1.54",
  "foundations-assets": "/foundations-assets/static-1.4775",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2054",
  "hs-story-utils": "/hs-story-utils/static-1.9354",
  "react-aria": "/react-aria/static-1.64",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1594",
  "hs-locale-management": "/hs-locale-management/static-1.23",
  "superstore": "/superstore/static-1.4692",
  "csstype": "/csstype/static-1.50",
  "rpc-client-utils": "/rpc-client-utils/static-1.4568",
  "emoji-regex": "/emoji-regex/static-1.7",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7957",
  "bender-build-tools": "/bender-build-tools/static-1.3093",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2821",
  "foundations-theming-base": "/foundations-theming-base/static-1.3323",
  "stylex": "/stylex/static-1.30",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9782",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9780",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4946",
  "chirp-fetch": "/chirp-fetch/static-1.1806",
  "ts-schema": "/ts-schema/static-1.4017",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58"
}
};
